import { MutationTree } from 'vuex';
import { State } from './state';
import { ConfigurationMutationTypes as MutationTypes } from './mutation-types';
import * as StorageConstants from '@/constants/storage-constants'
import SentrySingleton from '@/singletons/sentry-singleton';

export type Mutations<S = State> = {
  [MutationTypes.SET_CONFIG_BAGSIZE](state: S, payload: string | null): void;
  [MutationTypes.SET_CONFIG_BODY](state: S, payload: string | null): void;
  [MutationTypes.SET_CONFIG_EDGE](state: S, payload: string | null): void;
  [MutationTypes.SET_CONFIG_THREAD](state: S, payload: string | null): void;
  [MutationTypes.SET_CONFIG_INSIDE](state: S, payload: string | null): void;
  [MutationTypes.SET_CONFIG_POCKET](state: S, payload: string | null): void;
  [MutationTypes.SET_CONFIG_SIDE](state: S, payload: string | null): void;
  [MutationTypes.SET_CONFIG_FRONT](state: S, payload: string | null): void;
  [MutationTypes.SET_CONFIG_TACK](state: S, payload: string | null): void;
  [MutationTypes.SET_CONFIG_BACK](state: S, payload: string | null): void;
  [MutationTypes.SET_CONFIG_NAMECHAR](state: S, payload: string | null): void;
  [MutationTypes.SET_CONFIG_NAEMTHREAD](state: S, payload: string | null): void;
  [MutationTypes.SET_CONFIG_NONAME](state: S, payload: string | null): void;

  [MutationTypes.CONFIG_LOADED](state: S, payload: boolean): void;
}



export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.SET_CONFIG_BAGSIZE](state: State, payload: string) {
    try {
      checkLocalStorage()
      state.configBagsizeId = payload;
      log(MutationTypes.SET_CONFIG_BAGSIZE, payload)
      if (saveLocalStorage) {
        localStorage.setItem(StorageConstants.bagsize, payload);
      }
    }
    catch (err) {
      SentrySingleton.instance.captureException(err)
    }
  },
  [MutationTypes.SET_CONFIG_BODY](state: State, payload: string) {
    try {
      checkLocalStorage()
      state.configBodyId = payload;
      log(MutationTypes.SET_CONFIG_BODY, payload)
      if (saveLocalStorage) {
        localStorage.setItem(StorageConstants.body, payload);
      }
    }
    catch (err) {
      SentrySingleton.instance.captureException(err)
    }
  },
  [MutationTypes.SET_CONFIG_EDGE](state: State, payload: string) {
    try {
      checkLocalStorage()
      state.configEdgeId = payload;
      log(MutationTypes.SET_CONFIG_EDGE, payload)
      if (saveLocalStorage) {
        localStorage.setItem(StorageConstants.edge, payload);
      }
    }
    catch (err) {
      SentrySingleton.instance.captureException(err)
    }
  },
  [MutationTypes.SET_CONFIG_THREAD](state: State, payload: string) {
    try {
      checkLocalStorage()
      state.configThreadId = payload;
      log(MutationTypes.SET_CONFIG_THREAD, payload)
      if (saveLocalStorage) {
        localStorage.setItem(StorageConstants.thread, payload);
      }
    }
    catch (err) {
      SentrySingleton.instance.captureException(err)
    }
  },
  [MutationTypes.SET_CONFIG_INSIDE](state: State, payload: string) {
    try {
      checkLocalStorage()
      state.configInsideId = payload;
      log(MutationTypes.SET_CONFIG_INSIDE, payload)
      if (saveLocalStorage) {
        localStorage.setItem(StorageConstants.inside, payload);
      }
    }
    catch (err) {
      SentrySingleton.instance.captureException(err)
    }
  },
  [MutationTypes.SET_CONFIG_POCKET](state: State, payload: string) {
    try {
      checkLocalStorage()
      state.configPocketId = payload;
      log(MutationTypes.SET_CONFIG_POCKET, payload)
      if (saveLocalStorage) {
        localStorage.setItem(StorageConstants.pocket, payload);
      }
    }
    catch (err) {
      SentrySingleton.instance.captureException(err)
    }
  },
  [MutationTypes.SET_CONFIG_SIDE](state: State, payload: string) {
    try {
      checkLocalStorage()
      state.configSideId = payload;
      log(MutationTypes.SET_CONFIG_SIDE, payload)
      if (saveLocalStorage) {
        localStorage.setItem(StorageConstants.side, payload);
      }
    }
    catch (err) {
      SentrySingleton.instance.captureException(err)
    }
  },
  [MutationTypes.SET_CONFIG_FRONT](state: State, payload: string) {
    try {
      checkLocalStorage()
      state.configFrontId = payload;
      log(MutationTypes.SET_CONFIG_FRONT, payload)
      if (saveLocalStorage) {
        localStorage.setItem(StorageConstants.front, payload);
      }
    }
    catch (err) {
      SentrySingleton.instance.captureException(err)
    }
  },
  [MutationTypes.SET_CONFIG_TACK](state: State, payload: string) {
    try {
      checkLocalStorage()
      state.configTackId = payload;
      log(MutationTypes.SET_CONFIG_TACK, payload)
      if (saveLocalStorage) {
        localStorage.setItem(StorageConstants.tack, payload);
      }
    }
    catch (err) {
      SentrySingleton.instance.captureException(err)
    }
  },
  [MutationTypes.SET_CONFIG_BACK](state: State, payload: string) {
    try {
      checkLocalStorage()
      state.configBackId = payload;
      log(MutationTypes.SET_CONFIG_BACK, payload)
      if (saveLocalStorage) {
        localStorage.setItem(StorageConstants.back, payload);
      }
    }
    catch (err) {
      SentrySingleton.instance.captureException(err)
    }
  },
  [MutationTypes.SET_CONFIG_NAMECHAR](state: State, payload: string) {
    try {
      checkLocalStorage()
      state.configNamechar = payload;
      log(MutationTypes.SET_CONFIG_NAMECHAR, payload)
      if (saveLocalStorage) {
        localStorage.setItem(StorageConstants.namechar, payload);
      }
    }
    catch (err) {
      SentrySingleton.instance.captureException(err)
    }
  },
  [MutationTypes.SET_CONFIG_NAEMTHREAD](state: State, payload: string) {
    try {
      checkLocalStorage()
      state.configNamethreadId = payload;
      log(MutationTypes.SET_CONFIG_NAEMTHREAD, payload)
      if (saveLocalStorage) {
        localStorage.setItem(StorageConstants.namethread, payload);
      }
    }
    catch (err) {
      SentrySingleton.instance.captureException(err)
    }
  },
  [MutationTypes.SET_CONFIG_NONAME](state: State, payload: string) {
    try {
      checkLocalStorage()
      state.configNonameId = payload;
      log(MutationTypes.SET_CONFIG_NONAME, payload)
      if (saveLocalStorage) {
        localStorage.setItem(StorageConstants.noName, payload);
      }
    }
    catch (err) {
      SentrySingleton.instance.captureException(err)
    }
  },

  [MutationTypes.CONFIG_LOADED](state: State, payload: boolean) {
    state.configLoaded = payload;
  },
};

let saveLocalStorage: boolean | null = null
const checkLocalStorage = () => {
  try {
    if (saveLocalStorage == null) {
      localStorage.setItem("localstorage_test", "test");
      saveLocalStorage = !window.location.pathname.includes('renderer.html') && !window.location.pathname.includes('vieworder.html')
    }
  }
  catch (err) {
    // on some browser like LINE, there is no localstorage; ignore that error
    console.error(err)
    saveLocalStorage = false
  }
}

const log = (mut: MutationTypes, msg: any) => {
  console.log(mut + ' ' + msg)
}
